import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

// Import both versions
import AppV1 from './v1/App';
import AppV2 from './v2/App';
import AnalyticsTracker from './AnalyticsTracker';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AnalyticsTracker />
      <Routes>
        {/* Redirect root to v2 */}
        <Route path="/" element={<Navigate to="/v2" replace />} />
        
        {/* V1 Routes */}
        <Route path="/v1/*" element={<AppV1 />} />
        
        {/* V2 Routes */}
        <Route path="/v2/*" element={<AppV2 />} />

        {/* Catch all unknown routes and redirect to v2 */}
        <Route path="*" element={<Navigate to="/v2" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
